const styles = {
    error_message: {
        marginTop: '24px',
        color: '#ED0000',
        fontFamily: 'Silka_Regular',
        fontWeight: '400',
        fontSize: '14px',
        lineHeight: '21px',
    },
    confirmPass_Btn: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        borderRadius: '16px',
        fontSize: '16px',
        textTransform: 'none',
        marginTop: '40px',
        backgroundColor: '#3876AA',
        color: '#FFFFFF',
    },
    title: {
        fontFamily: 'Silka_Bold',
        fontWeight: 700,
        fontSize: '28px',
        lineHeight: '42px',
    },
    subTitle: {
        fontFamily: 'Silka_Regular',
        fontWeight: 400,
        fontSize: '18px',
        lineHeight: '27px',
        marginBottom: '48px',
        color: '#3876AA',
    },
    description: {
        fontFamily: 'Silka_Regular',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '21px',
        color: '#27344E',
    },
    divider: {
        color: '#E0E4ED',
        marginTop: '24px',
        marginBottom: '24px',
    },
    email: {
        color: '#56ace3',
        pl: '4px',
        pr: '4px',
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
    },
};
export default styles;
